<template>
  <div>
    <div class="row">
      <label class="col-sm-2 control-label" for="company_id">Company:</label>
      <div class="col-sm-4">
        <select class="form-control" name="company_id" v-model="selectedCompany" @change="fetchCompanyOfferings">
          <option value="">-- Select Company --</option>
          <option v-for="(companyName, companyId) in companyOptions" :key="companyId" :value="companyId">
            {{ companyName }}
          </option>
        </select>
      </div>
    </div>

    <div class="row">
      <label class="col-sm-2 control-label"></label>
      <div class="col-sm-4">
        <div class="checkbox checkbox-primary">
          <input type="checkbox" name="duplicate_offering" v-model="showSelect" />
          <label>Duplicate an existing room?</label>
        </div>

      </div>
    </div>
    
    <div v-if="showSelect">
      <div class="row">
        <label class="col-sm-2 control-label" for="offerings">Select existing offering:</label>
        <div class="col-sm-4">
          <select class="form-control" name="offering_id" v-model="selectedOffering">
            <option value="">-- Select Offering --</option>
            <option v-for="offering in companyOfferings" :key="offering.id" :value="offering.id">
              {{ offering.id }} - {{ offering.name }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="form-group">
          <label class="col-md-2 control-label" for="name">
            New Offering Name:
          </label>
          <div class="col-md-4">
              <input class="form-control" name="name"/>
          </div>
      </div>
    </div>

    <input type="submit" name="submit" value="Provision" class="btn btn-default"/>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "OfferingCreateForm",
  data() {
    return {
      showSelect: false,
      companyOptions: window.companyOptions || [],
      activeEmd: window.activeEmd,
      selectedCompany: "",
      selectedOffering: "",
      companyOfferings: [],
    };
  },
  methods: {
    fetchCompanyOfferings() {
      axios.get(`/admin/${activeEmd.slug}/companies_offerings/${this.selectedCompany}`)
        .then(response => {
          console.log(response.data);
          this.companyOfferings = response.data.companyOfferings;
        })
        .catch(error => {
          console.error("Error fetching company offerings:", error);
        });
    },
  },
};
</script>
